import React from 'react';

const DatePickerIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M6 11.0002C5.53333 11.0002 5.13889 10.8391 4.81667 10.5168C4.49444 10.1946 4.33333 9.80016 4.33333 9.3335C4.33333 8.86683 4.49444 8.47239 4.81667 8.15016C5.13889 7.82794 5.53333 7.66683 6 7.66683C6.46667 7.66683 6.86111 7.82794 7.18333 8.15016C7.50556 8.47239 7.66667 8.86683 7.66667 9.3335C7.66667 9.80016 7.50556 10.1946 7.18333 10.5168C6.86111 10.8391 6.46667 11.0002 6 11.0002ZM3.33333 14.6668C2.96667 14.6668 2.65278 14.5363 2.39167 14.2752C2.13056 14.0141 2 13.7002 2 13.3335V4.00016C2 3.6335 2.13056 3.31961 2.39167 3.0585C2.65278 2.79739 2.96667 2.66683 3.33333 2.66683H4V1.3335H5.33333V2.66683H10.6667V1.3335H12V2.66683H12.6667C13.0333 2.66683 13.3472 2.79739 13.6083 3.0585C13.8694 3.31961 14 3.6335 14 4.00016V13.3335C14 13.7002 13.8694 14.0141 13.6083 14.2752C13.3472 14.5363 13.0333 14.6668 12.6667 14.6668H3.33333ZM3.33333 13.3335H12.6667V6.66683H3.33333V13.3335Z'
        fill='#49454F'
      />
    </svg>
  );
};

export default DatePickerIcon;
